export default __webpack_public_path__ + "static/media/iconImg.1ef1d290.svg";